import { Helmet } from 'react-helmet-async';
import {Grid, Button, Container, Stack, Typography, TextField, CircularProgress, InputAdornment} from '@mui/material';
import Iconify from '../../components/iconify';
import { useMutation, useQuery } from '@apollo/client';
import { GET_ALL_ANNUAL_RETURN_REQUEST_PAGINATED } from 'src/graphql/queries/trademark';
import { UPDATE_TRADEMARK_STATUS } from 'src/graphql/mutations/trademark';
import { useEffect, useState } from 'react';
import { useSnackbar } from 'notistack';
import AnnualReturnRequestCard from 'src/sections/@dashboard/annual return/AnnualReturnRequestCard';
import { debounce } from 'lodash';
import TrademarkRequestCard from "../../sections/@dashboard/trademark/TrademarkRequestCard";

export default function AdminTrademark() {
    const [page, setPage] = useState(1);
    const pageSize = 10;
    const { data: data2, loading: loadingData2, fetchMore } = useQuery(GET_ALL_ANNUAL_RETURN_REQUEST_PAGINATED, {
        variables: { page, pageSize },
    });

    const [annualReturnRequests, setAnnualReturnRequests] = useState([]);
    const [updateStatus, setUpdateStatus] = useState(false);
    const [updateTrademark, { data: updatedReservation, loading }] =
        useMutation(UPDATE_TRADEMARK_STATUS);
    const { enqueueSnackbar } = useSnackbar();

    const [filtered, setFiltered] = useState([]);
    const [searchTerm, setSearchTerm] = useState('');
    const [searchLoading, setSearchLoading] = useState(false); // New state for search loading

    useEffect(() => {
        if (data2 && data2?.allTrademark) {
            setAnnualReturnRequests(data2.allTrademark.trademarks);
        }
    }, [data2]);

    useEffect(() => {
        setFiltered(annualReturnRequests);
    }, [annualReturnRequests,]);

    useEffect(() => {
        if (updatedReservation?.updateTrademark && updateStatus) {
            setUpdateStatus(false);
            let tempReservations = [...annualReturnRequests];
            const objIndex = tempReservations.findIndex(
                (obj) => obj._id === updatedReservation?.updateTrademark?._id
            );
            tempReservations[objIndex].status = updatedReservation?.updateTrademark?.status;
            setAnnualReturnRequests(tempReservations);
        }
    }, [updatedReservation?.updateTrademark, annualReturnRequests, updateStatus]);

    const changeStatus = async (_id, status, adminMessage) => {
        setUpdateStatus(true);
        enqueueSnackbar('Status updated!');
        await updateTrademark({
            variables: { input: { _id, status, adminMessage } },
        });
    };

    const handlePageChange = async (newPage) => {
        setPage(newPage);
        await fetchMore({
            variables: { page: newPage, pageSize, searchTerm },
            updateQuery: (prev, { fetchMoreResult }) => {
                if (!fetchMoreResult) return prev;
                return fetchMoreResult;
            },
        });
    };

    const handleSearchDebounced = debounce(async (newSearchTerm) => {
        setSearchTerm(newSearchTerm);
        setPage(1);
        setSearchLoading(true);
        await fetchMore({
            variables: { page, pageSize, searchTerm: newSearchTerm },
            updateQuery: (prev, { fetchMoreResult }) => {
                if (!fetchMoreResult) return prev;
                console.log({fetchMoreResult, newSearchTerm} )
                return fetchMoreResult;
            },
        });
        setSearchLoading(false);

    }, 200);

    const handleSearchChange = (event) => {
        const newSearchTerm = event.target.value;
        setSearchTerm(newSearchTerm);
        setSearchLoading(false);
        handleSearchDebounced(newSearchTerm);
    };

    return (
        <>
            <Helmet>
                <title> Trademark | BeeBot </title>
            </Helmet>

            <Container>
                <Stack direction="row" alignItems="center" justifyContent="space-between" mb={5}>
                    <Typography variant="h4" gutterBottom>
                        Trademarks
                    </Typography>
                    <Button variant="contained" startIcon={<Iconify icon="eva:plus-fill" />}>
                        New Record
                    </Button>
                </Stack>

                <Grid container spacing={3}>
                    <Grid item md={12} sm={12}>
                        <TextField
                            value={searchTerm}
                            fullWidth
                            placeholder="Search Reservation by Company name..."
                            onChange={handleSearchChange}
                            InputProps={{
                                endAdornment: (
                                    <InputAdornment position="end">
                                        {searchLoading && <CircularProgress size={20} />}
                                    </InputAdornment>
                                ),
                            }}
                        />
                    </Grid>

                    {filtered?.map((post, index) => (
                        <TrademarkRequestCard key={post._id} post={post} index={index} loading={loading} changeStatus={changeStatus} />
                    ))}

                    <Grid item md={12} sm={12} container justifyContent="center" alignItems="center" spacing={2}>
                        <Grid item>
                            <Button variant="outlined" onClick={() => handlePageChange(page - 1)} disabled={page <= 1 || loadingData2}>
                                Previous
                            </Button>
                        </Grid>
                        <Grid item>
                            <Typography variant="body2">Page {page}</Typography>
                        </Grid>
                        <Grid item>
                            <Button
                                variant="outlined"
                                onClick={() => handlePageChange(page + 1)}
                                disabled={page >= data2?.allTrademark.pageInfo?.totalPages || loadingData2}
                            >
                                Next
                            </Button>
                        </Grid>
                        {loadingData2 && <CircularProgress size={24} />}
                    </Grid>
                </Grid>
            </Container>
        </>
    );
}
